// ActionRequired.tsx
import { FC, Fragment,memo, useEffect, useState } from "react";
import ActionRequiredTableHeader from "src/components/actionDashboard/actionRequiredTableHeader";
import ActionRequiredTableRow from "src/components/actionDashboard/actionRequiredTableRow";
import PaginationNav from "src/components/actionDashboard/paginationNav";
import { ActionRequiredTypeProps, TodoDataProps } from "./types";
import NoDataFound from "src/components/noDataFoundComponent";
import { QueryParamsState } from "src/components/manufacturer/caseListing";


const ActionRequired: FC<ActionRequiredTypeProps> = ({ tableData, currentPage, onPageChange, refreshListing }) => {
const [queryParam, setQueryParam] = useState<QueryParamsState>({
       direction: "desc",
       sort_by: "bi_case_id",
     });
   
     const [sortedData, setSortedData] = useState<TodoDataProps[]>([]);
   
     // Initialize sortedData whenever new data comes from props
     useEffect(() => {
       if (tableData?.todos_data) {
         setSortedData([...tableData.todos_data]);
       }
     }, [tableData]);
   
     const changeIdOrder = (tableHeader: string) => {
       const newParams: QueryParamsState = {
         sort_by: tableHeader,
         direction:
           tableHeader === queryParam.sort_by
             ? queryParam.direction === "desc"
               ? "asc"
               : "desc"
             : "desc",
       };
   
       let sorted = [...(tableData?.todos_data || [])];
   
       switch (newParams.sort_by) {
         case "bi_case_id":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.bi_case_id) - Number(b.bi_case_id)
               : Number(b.bi_case_id) - Number(a.bi_case_id)
           );
           break;
   
         case "patient_id":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? Number(a.patient_id) - Number(b.patient_id)
               : Number(b.patient_id) - Number(a.patient_id)
           );
           break;
   
         case "drug_name":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.drug_name || "").localeCompare(b.drug_name || "")
               : (b.drug_name || "").localeCompare(a.drug_name || "")
           );
           break;
   
         case "patient_name":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.patient_name || "").localeCompare(b.patient_name || "")
               : (b.patient_name || "").localeCompare(a.patient_name || "")
           );
           break;
   
         case "bi_completed":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.bi_completed || "").localeCompare(b.bi_completed || "")
               : (b.bi_completed || "").localeCompare(a.bi_completed || "")
           );
           break;
   
        //  case "bi_submitted":
        //    sorted.sort((a, b) =>
        //      newParams.direction === "asc"
        //        ? (a.bi_submitted || "").localeCompare(b.bi_submitted || "")
        //        : (b.bi_submitted || "").localeCompare(a.bi_submitted || "")
        //    );
        //    break;
   
         case "payer":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.payer || "").localeCompare(b.payer || "")
               : (b.payer || "").localeCompare(a.payer || "")
           );
           break;
   
         case "physician":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.physician || "").localeCompare(b.physician || "")
               : (b.physician || "").localeCompare(a.physician || "")
           );
           break;
   
         case "medical_coverage_status":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.medical_coverage_status || "").localeCompare(b.medical_coverage_status || "")
               : (b.medical_coverage_status || "").localeCompare(a.medical_coverage_status || "")
           );
           break;
   
         case "pharmacy_coverage_status":
           sorted.sort((a, b) =>
             newParams.direction === "asc"
               ? (a.pharmacy_coverage_status || "").localeCompare(b.pharmacy_coverage_status)
               : (b.pharmacy_coverage_status).localeCompare(a.pharmacy_coverage_status)
           );
           break;
   
         default:
           break;
       }
   
       setSortedData(sorted);
       setQueryParam(newParams);
     };

  return (
    <Fragment>
      <div className="table-responsive-sm table-responsive-md table-responsive-lg flex-fill">
        <table className="table table-striped table-sm m-0">
          <ActionRequiredTableHeader queryParam={queryParam}
            changeIdOrder={changeIdOrder}/>
          <tbody>
            {sortedData && sortedData.length>0 ? sortedData.map((item: TodoDataProps, index: number) => (
              <ActionRequiredTableRow
                data={item}
                refreshListing={refreshListing}
                index={index}
              />
            )):<NoDataFound/>
            }
          </tbody>
        </table>
      </div>
      {tableData?.page_count > 1 && (
        <PaginationNav currentPage={currentPage} pageCount={tableData.page_count} onPageChange={onPageChange} />
      )}
    </Fragment>
  );
};

export default memo(ActionRequired);
